module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-bg-2-e1c4a1e035f7f94eb8b9e1a8e8181690.png";